import React from "react";
import type { FieldValues, UseControllerProps } from "react-hook-form";
import { getOctopusCloudRegions } from "client/api/OctopusCloudRegionApi";
import { EntitySelector } from "../EntitySelector/EntitySelector";

type CloudRegionSelectorProps<T extends FieldValues> = UseControllerProps<T> & {
  label?: string;
  required?: boolean;
};

function searchCloudRegions(searchTerm?: string) {
  //We don't have many regions, so we can just return all of them,
  //but we can add filtering if needed
  return getOctopusCloudRegions();
}

export function CloudRegionSelector<T extends FieldValues>(props: CloudRegionSelectorProps<T>) {
  const { label, required, ...rest } = props;
  return (
    <EntitySelector
      {...rest}
      label={label || "Cloud region"}
      apiRequest={searchCloudRegions}
      optionLabelFunc={(r) => r.id}
      required={required}
    />
  );
}
